export default {
  setPagination(state, pagination) {
    state.pagination = pagination;
  },
  setQuizes(state, quizes) {
    state.quizes = quizes;
  },
  setFinalQuiz(state, final_quiz) {
    state.final_quiz = final_quiz;
  }
};
